import { Control } from 'react-hook-form';
import type { CreateVisitType } from '@features/visits/entity';
import ServicesAutoComplete from '@features/service/components/ServicesAutoComplete';
import { useReservationServicesQuery } from '@features/customer-reservations/queries';

type CustomerServiceSelectionSectionProps = {
  control: Control<CreateVisitType>;
  onServiceChange: (serviceId: string) => void;
};

const CustomerServiceSelect = ({
  control,
  onServiceChange,
}: CustomerServiceSelectionSectionProps) => {
  const { data, isLoading } = useReservationServicesQuery();
  const services = data?.services;

  return (
    <ServicesAutoComplete
      fieldPath="serviceIds"
      control={control}
      onChange={service => {
        if (!service) {
          return;
        }

        onServiceChange(service.id);
      }}
      queryData={services}
      isLoading={isLoading}
    />
  );
};

export default CustomerServiceSelect;
